import React from 'react'
import Typist from 'react-typist'
import { Col, Badge, Alert } from 'reactstrap'

import PageBreadcrumb from '../Common/PageBreadcrumb'
// import images
import services from '../../assets/images/salary/services.svg'

//React Typist

const Section = () => {
  return (
    <section className="projects-area d-table w-100" id="home">
      <div className="container">
        <div className="row align-items-center">
          <div className="col col-lg-7 col-md-7">
            <div className="title-heading mt-4">
              <Alert
                className="alert-pills"
                role="alert"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <Badge color="success" pill className="mr-1">
                  Daren Payroll
                </Badge>
                <span className="content"> 薪酬福利管理</span>
              </Alert>
              <h1 className="heading mb-3">
                我们帮助你{' '}
                <Typist>
                  <span className="element text-primary">薪酬核算</span>
                  <Typist.Backspace count={20} delay={500} />
                  <span className="element text-primary">社保福利</span>
                  <Typist.Backspace count={20} delay={500} />
                  <span className="element text-primary">新版个税核算</span>
                  <Typist.Backspace count={20} delay={500} />
                  <span className="element text-primary">工资条发放</span>
                  <Typist.Backspace count={20} delay={500} />
                  <span className="element text-primary">薪酬数据统计</span>
                </Typist>
              </h1>
              <p className="para-desc text-muted">
                薪酬计划人员也可以从繁重的行政工作中解放出来，专注于更有价值的工作
              </p>
            </div>
          </div>

          <Col className="col col-lg-5 col-md-5">
            <img src={services} alt="工资计算软件" />
          </Col>
        </div>
      </div>
      <PageBreadcrumb homePageText="首页" homePageUrl="/" activePageText="薪酬福利" />

      <div className="position-relative">
        <div className="shape overflow-hidden text-light">
          <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
    </section>
  )
}

export default Section
